import "./Fac.css";

// import Rectangle from "Rectangle.png";
import  useScrollToTop from "../../hooks/useScrollToTop"
import GetAppointment from '../../components/GetAppointment'
import { Helmet } from "react-helmet";
function Fac() {
  useScrollToTop();
  return (
    
    // <!-- Main Heading ----------------------------------------------->

    <div  className="Facilities">
         <Helmet>
     
     <meta charSet="utf-8" />
     <title>top ent facilities in Surat,Navsari,Bardoli Gujarat - Sudeep ENT Hospital</title>
     <meta name="description" content="Meet Dr. Prayatna Kumar & Dr. Vidhi Gupta, a leading ENT and Cochlear Specialist serving Surat, Navsari, and Bardoli. Learn about Dr. Prayatna Kumar & Dr. Vidhi Gupta's expertise and commitment to providing top-quality ear, nose, and throat care."></meta>
     <meta name="keywords" content="top 5 ent specialist in surat, ent specialist in surat city light, best ent hospital in surat, top 3 et doctirs in surat"></meta>
     <meta name="author" content="Sudeep ENT Hospital"></meta>
     <link rel="canonical" href="https://sudeepenthospital.com/facilities" />
     <meta name="robots" content="index, follow" />
</Helmet>
      <div className="header-sec">
        <div className="heading_fac">
        <p >Services & Facilities</p>
      </div>
      <div className="header_content">
        <div className="snf_image">
          <img src="surgery.png" alt="Images" />
        </div>
        <div className="snf_content">
          <p>
            The clinical expertise and nursing care provided by Sudeep ENT
            Hospital are of the highest caliber in a variety of disciplines. We
            provide a variety of services in the healthcare industry. Our
            priority is providing excellent service at a fair price. Our goal is
            to guarantee that all demographic groups have access to inexpensive
            healthcare services, and our mission is to provide quality-driven
            services. <br />
            <br />
            Sudeep ENT Hospital is meticulous in its attention to detail and our
            patients' welfare. We continuously aim for a quality culture, one
            that emphasizes ongoing development and superior patient care and
            services. Our comprehensive reporting of our quality data and care
            reflects our commitment to offering the greatest calibre of care. In
            addition to the medical services we offer, City goes above and above
            to meet our patients' healthcare needs.
          </p>

          <div className="apt_box">
           <GetAppointment/>

          </div>
        </div>
      </div>
      </div>
    {/* <!-- General Facilities -----------------------------------> */}
     <div className="facilities-headings general-fac">
        <h1>General <span class="highlight">Facilities</span></h1>
        <div className="facilities-list">
            <div className="col-1">
            <ul >
              <li>Modular OT with Laminar Flow</li>
              <li>Vertigo Lab</li>
              <li>Karl Storz Spice Camera</li>
            </ul>
            </div>
            <div className="col-2">
            <ul >
              <li>Zeiss Microscope</li>
              <li>Audiologist</li>
              <li>Speech Room</li>
            </ul>
            </div>
            <div className="col-3">
            <ul >
              <li>Mediclaim</li>
              <li>Cashless Transactions</li>
              <li>Speech Therapy</li>
            </ul>
            </div>
        </div>
        </div>
  {/* <!-- Special Surgery boxes ---------------------------------------------> */}
  <div className="facilities-headings Special-surgeries">
        <h1>Special <span class="highlight">Facilities</span></h1>
    <div className="all-boxes">

      
        <div className="box">  <a href="#box1">
            <div className="box-text">
               
                COCHLEAR IMPLANT SURGERY
               
            </div></a>
        </div>
        

       
        <div className="box"> <a href="#box2">
            <div className="box-text">
                
            VERTIGO CLINIC
            </div> </a>
        </div>
       

        
        <div className="box"><a href="#box3">
            <div className="box-text">
            EAR DISCHARGE AND TYMPANOMASTOID SURGERY
            </div></a>
        </div>
        
        
       
        <div className="box"> <a href="#box4">
            <div className="box-text">
            SKULL BASE SURGERIES
            </div></a>
        </div>
        
        
       
        <div className="box"> <a href="#box5">
            <div className="box-text">
            SNORING AND SLEEP APNOEA CLINIC
            </div> </a>
        </div>
       
        
        
        <div className="box"><a href="#box6">
            <div className="box-text">
            TONSILLECTOMY AND ADENOID SURGERIES
            </div> </a>
        </div>
       
        
        
        <div className="box"><a href="#box7">
            <div className="box-text">
            MICROEAR SURGERY
            </div></a>
        </div>
        
        
       
        <div className="box"> <a href="#box8">
            <div className="box-text">
            ALLERGY CLINIC
            </div> </a>
        </div>
       
        
      
        <div className="box">  <a href="#box9">
            <div className="box-text">
            OTOSCLEROSIS AND STAPES SURGERY
            </div> </a>
        </div>
       
        
       
        <div className="box"> <a href="#box10">
            <div className="box-text">
            LARYNGOLOGY AND MICROLARYNGEAL SURGERY
            </div>  </a>
        </div>
      
    </div>


    </div>
    {/* <!-- Special Surgery boxes ---------------------------------------------> */}
    <div className="surgeries-para">
        {/* ------- */}
        <div className="surgery-para-head">
            <h1 id="box1">COCHLEAR IMPLANT SURGERY</h1> 
            <div className="underlined-heading"></div>

        </div>
        <div className="surgery-details" >
                <img src="c.png" alt="best-cochlear-implant-surat"  />
                <div className="para-details">
                    <p>Cochlear implant surgery is a procedure that aims to restore hearing in individuals with severe to profound hearing loss. It involves the insertion of an electronic device into the inner ear, stimulating the auditory nerve and bypassing damaged or non-functioning hair cells. The implant consists of an external speech processor and an internal receiver-stimulator, working together to provide sound perception and understanding.</p>
                    <h2>AFTER SURGERY</h2>
                    <p>After cochlear implant surgery, it is important to take certain precautions to ensure proper healing and optimal outcomes. Patients are advised to avoid water exposure to the surgical site for several weeks and refrain from activities that may cause pressure or trauma to the head. They should also follow the recommended guidelines for device activation, mapping sessions, and regular follow-up appointments with their audiologist for adjustment and rehabilitation.</p>
                    <div className="know-more"><a href=" https://www.mayoclinic.org/tests-procedures/cochlear-implants/about/pac-20385021" target="_blank"  rel="noreferrer">Know More</a></div>
            </div>
        </div>
        {/* ------- */}
        
         <div className="surgery-para-head">
            <h1 id="box2">VERTIGO</h1> 
            <div className="underlined-heading"></div>

        </div>
        <div className="surgery-details" >
                <img src="VERTIGO.png" alt="best-cochlear-implant-surat"  />
                <div className="para-details">
                    <p> Vertigo is a symptom characterized by a spinning or whirling sensation, often accompanied by dizziness, imbalance, and nausea. It is commonly caused by disturbances in the inner ear, such as benign paroxysmal positional vertigo (BPPV), vestibular neuritis, or Ménière's disease. Treatment options for vertigo depend on the underlying cause and may include medication, physical therapy exercises, or in some cases, surgical interventions.</p>
                    <h2>AFTER SURGERY</h2>
                    <p> After vertigo surgery, it is crucial to take specific precautions to support the healing process and prevent complications. Patients are typically advised to avoid sudden head movements, strenuous activities, and lifting heavy objects for a certain period. They should also follow post-operative instructions regarding medication usage, wound care, and scheduled follow-up visits with their healthcare provider to monitor progress and address any concerns.</p>
                    <div className="know-more"><a href="https://www.nhsinform.scot/illnesses-and-conditions/ears-nose-and-throat/vertigo#:~:text=Vertigo%20is%20a%20symptom%2C%20rather,balance%20and%20do%20everyday%20tasks." target="_blank"  rel="noreferrer">Know More</a></div>
            </div>
        </div>
        {/* ------- */}
        
         <div className="surgery-para-head">
            <h1 id="box3">EAR DISCHARGE AND TYMPANOMASTOID SURGERY</h1> 
            <div className="underlined-heading"></div>

        </div>
        <div className="surgery-details" >
                <img src="EAR_DISCHARGE.png" alt="best-ent-doctore-surat"  />
                <div className="para-details">
                    <p> When the discharge is persistent or recurrent and associated with chronic infections or structural abnormalities, tympanomastoid surgery may be performed. This surgical procedure aims to address the underlying issues within the middle ear and mastoid bone, such as cholesteatoma or chronic otitis media, by removing infected tissue, reconstructing damaged structures, and improving overall ear health.</p>
                    <h2>AFTER SURGERY</h2>
                    <p> After ear discharge and tympanomastoid surgery, it is important to take precautions to promote healing and prevent complications. Patients are typically advised to avoid getting water into the operated ear, refrain from blowing the nose forcefully, and follow the prescribed antibiotic regimen. It is crucial to attend follow-up appointments for dressing changes and monitoring of the surgical site to ensure proper recovery and address any concerns.</p>
                    <div className="know-more"><a href="https://fortworthent.net/audiology-hearing-loss/tympanoplasty-mastoidectomy/#:~:text=Tympanomastoidectomy%20procedure%20is%20performed%20in,or%20the%20cholesteatoma%20is%20removed" target="_blank"  rel="noreferrer">Know More</a></div>
            </div>
        </div>
        {/* ------- */}
    
         <div className="surgery-para-head">
            <h1 id="box4">SKULL BASE SURGERIES</h1> 
            <div className="underlined-heading"></div>

        </div>
        <div className="surgery-details" >
                <img src="SKULL_BASE.png" alt=""  />
                <div className="para-details">
                    <p>Skull base surgeries are complex procedures performed to address various conditions involving the base of the skull and the structures within it. These surgeries aim to remove tumors, repair defects, treat vascular abnormalities, or alleviate nerve compression. They are typically conducted through minimally invasive techniques or open approaches, depending on the specific condition. Close collaboration between neurosurgeons, otolaryngologists, and other specialists is essential for successful outcomes.</p>
                    <h2>AFTER SURGERY</h2>
                    <p>After skull base surgeries, taking precautions is crucial to support healing and reduce the risk of complications. Patients are often advised to avoid strenuous physical activities, lifting heavy objects, and activities that may increase intracranial pressure. They should also follow the prescribed medication regimen, attend regular follow-up appointments, and report any new or worsening symptoms promptly to their healthcare team. Proper wound care, infection prevention measures are essential for a successful recovery.</p>
                    <div className="know-more"><a href="https://www.enthealth.org/be_ent_smart/what-is-skull-base-surgery/" target="_blank"  rel="noreferrer">Know More</a></div>
            </div>
        </div>
        {/* ------- */}
        
         <div className="surgery-para-head">
            <h1 id="box5">SNORING AND SLEEP APNOEA CLINIC</h1> 
            <div className="underlined-heading"></div>

        </div>
        <div className="surgery-details" >
                <img src="SNORING_AND_SLEEP.png" alt="best-ent-doctore-surat"  />
                <div className="para-details">
                    <p>  A snoring and sleep apnea clinic is a specialized medical facility that focuses on the evaluation, diagnosis, and treatment of snoring and sleep apnea disorders. These clinics typically offer comprehensive sleep assessments, including sleep studies, to assess the severity and underlying causes of sleep-related breathing disorders. Treatment options may include lifestyle modifications, oral appliances, continuous positive airway pressure (CPAP) therapy, surgical interventions, or a combination of approaches tailored to each patient's specific needs. The goal of these clinics is to improve sleep quality, reduce symptoms, and enhance overall health and well-being for individuals affected by snoring and sleep apnea.</p>
                    <h2>AFTER SURGERY</h2>
                    <p> Sudeep ENT Hospital is meticulous in its attention to detail and
                our patients' welfare. We continuously aim for a quality
                culture, one that emphasizes ongoing development and superior
                patient care and services.Sudeep ENT Hospital is meticulous in
                its attention to detail and our patients' welfare. We
                continuously aim for a quality culture, one that emphasizes
                ongoing development and superior patient care and services.</p>
                    <div className="know-more"><a href="https://www.mayoclinic.org/diseases-conditions/sleep-apnea/diagnosis-treatment/drc-20377636?sscid=61k7_8olq4&
" target="_blank"  rel="noreferrer">Know More</a></div>
            </div>
        </div>
        {/* ------- */}
        
         <div className="surgery-para-head">
            <h1 id="box6" >TONSILLECTOMY AND ADENOID SURGERIES</h1> 
            <div className="underlined-heading"></div>

        </div>
        <div className="surgery-details" >
                <img src="TONSILLECTOMY.png" alt="best-ent-doctore-surat"  />
                <div className="para-details">
                    <p> Tonsillectomy and adenoid surgeries involve removing the tonsils and adenoids to address chronic infections, sleep apnea, or related conditions. These procedures alleviate symptoms like recurrent sore throat and breathing difficulties. Post-surgery, patients follow care instructions for pain management, diet, and rest, with regular follow-up appointments for monitoring and support.</p>
                    <h2>AFTER SURGERY</h2>
                    <p>After tonsillectomy and adenoid surgeries, precautions include following a soft diet, avoiding strenuous activities, and maintaining good oral hygiene. Attend follow-up appointments for monitoring and promptly report any signs of infection or bleeding to the healthcare provider.</p>
                    <div className="know-more"><a href="https://www.ncbi.nlm.nih.gov/books/NBK536942/" target="_blank"  rel="noreferrer">Know More</a></div>
            </div>
        </div>
        {/* ------- */}
        
         <div className="surgery-para-head">
            <h1 id="box7">MICROEAR SURGERY</h1> 
            <div className="underlined-heading"></div>

        </div>
        <div className="surgery-details" >
                <img src="MICROEAR.png" alt="top 5 ent specialist in surat"  />
                <div className="para-details">
                    <p> Microear surgeries are precise procedures for treating middle and inner ear conditions. Using advanced techniques and high-resolution microscopy, they aim to restore hearing and improve ear function. Close monitoring and follow-up care are crucial for successful outcomes.</p>
                    <h2>AFTER SURGERY</h2>
                    <p>After microear surgeries, it is important to take precautions to promote healing and prevent complications. Patients should avoid water exposure to the surgical site, refrain from inserting objects into the ear, and follow post-operative care instructions for medication usage and wound care. Regular follow-up appointments are essential for monitoring progress and addressing any concerns for optimal recovery.</p>
                    <div className="know-more"><a href=" https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3451440/
" target="_blank"  rel="noreferrer">Know More</a></div>
            </div>
        </div>
        {/* ------- */}
       
         <div className="surgery-para-head">
            <h1 id="box8">ALLERGY CLINIC</h1> 
            <div className="underlined-heading"></div>

        </div>
        <div className="surgery-details" >
                <img src="ALLERGY_CLINIC.png" alt="top 5 ent specialist in surat"  />
                <div className="para-details">
                    <p>  An ENT Allergy Clinic is a specialized medical facility that focuses on the diagnosis and management of allergies related to the ear, nose, and throat. These clinics offer comprehensive evaluations and tests to identify specific allergens that may trigger symptoms such as nasal congestion, sneezing, itching, or chronic sinusitis. Treatment options may include allergen avoidance, medication therapy, immunotherapy, or a combination of approaches tailored to each patient's needs. The goal of an ENT Allergy Clinic is to provide relief, improve quality of life, and help patients effectively manage their allergic conditions.</p>
                    <h2>AFTER SURGERY</h2>
                    <p>Sudeep ENT Hospital is meticulous in its attention to detail and
                our patients' welfare. We continuously aim for a quality
                culture, one that emphasizes ongoing development and superior
                patient care and services.Sudeep ENT Hospital is meticulous in
                its attention to detail and our patients' welfare. We
                continuously aim for a quality culture, one that emphasizes
                ongoing development and superior patient care and services.</p>
                    <div className="know-more"><a href="https://www.example.com" target="_blank"  rel="noreferrer">Know More</a></div>
            </div>
        </div>
        {/* ------- */}
         
         <div className="surgery-para-head">
            <h1 id="box9">OTOSCLEROSIS AND STAPES SURGERY</h1> 
            <div className="underlined-heading"></div>

        </div>
        <div className="surgery-details" >
                <img src="OTOSCLEROSIS.png" alt="top 5 ent specialist in surat"  />
                <div className="para-details">
                    <p> Otosclerosis is a condition characterized by abnormal bone growth in the middle ear, leading to hearing loss. Stapes surgery, also known as stapedectomy or stapedotomy, is a surgical procedure performed to treat otosclerosis. During the surgery, the stapes bone is replaced or reshaped to improve sound transmission in the inner ear. The goal of stapes surgery is to restore or improve hearing and alleviate symptoms caused by otosclerosis.</p>
                    <h2>AFTER SURGERY</h2>
                    <p> After otosclerosis and stapes surgery, it is crucial to take precautions to support healing and prevent complications. Patients should avoid activities that could increase inner ear pressure, such as heavy lifting or straining. They should also follow post-operative care instructions, attend scheduled follow-up appointments for monitoring, and report any concerning symptoms promptly to their healthcare provider.</p>
                    <div className="know-more"><a href=" https://www.ncbi.nlm.nih.gov/pmc/articles/PMC7265776/
" target="_blank"  rel="noreferrer">Know More</a></div>
            </div>
        </div>
        {/* ------- */}
      
         <div className="surgery-para-head">
            <h1 id="box10">LARYNGOLOGY AND MICROLARYNGEAL SURGERY</h1> 
            <div className="underlined-heading"></div>

        </div>
        <div className="surgery-details" >
                <img src="LARYNGOLOGY.png" alt="top 5 ent specialist in surat"  />
                <div className="para-details">
                    <p> Laryngology and microlaryngeal surgery are specialized fields focusing on the diagnosis and treatment of voice and throat disorders. These surgeries involve minimally invasive techniques to address conditions like vocal cord nodules, polyps, or lesions. The aim is to restore voice function and alleviate symptoms while preserving vocal cord health and function.</p>
                    <h2>AFTER SURGERY</h2>
                    <p>  After laryngology and microlaryngeal surgery, precautions are essential for optimal healing and voice recovery. Patients are advised to rest their voice and avoid excessive talking or singing. They should follow post-operative care instructions, such as avoiding irritants, staying hydrated, and attending follow-up appointments for monitoring and voice rehabilitation if necessary.</p>
                    <div className="know-more"><a href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3546402/" target="_blank"  rel="noreferrer">KNOW MORE</a></div>
            </div>
        </div>
        {/* ------- */}
        
    </div>
      </div>
      
      )
      }

 export default Fac;    